import '@clickio/tokens/tokens.css';
import './global.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

const root = document.getElementById('root');
if (!root) throw new Error('#root не найден');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
